import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ReturnToSupplierHistoryState } from './return-to-supplier-history.reducers';

export const returnToSupplierHistoryKey = 'returnToSupplierHistory';
export const selectReturnToSupplierHistoryState =
  createFeatureSelector<ReturnToSupplierHistoryState>(returnToSupplierHistoryKey);

export const selectAllReturnToSupplierHistoryList = createSelector(
  selectReturnToSupplierHistoryState,
  (state) => state?.selected
);

export const selectReturnToSupplierHistoryListCriteria = createSelector(
  selectReturnToSupplierHistoryState,
  (state) => state?.criteriaObject
);

export const selectReturnToSupplierHistoryTotalElements = createSelector(
  selectReturnToSupplierHistoryState,
  (state) => state?.totalElements
);

export const selectReturnToSupplierHistoryIsLoading = createSelector(
  selectReturnToSupplierHistoryState,
  (state) => state?.isLoading
);
